import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import SvgColor from 'src/components/svg-color';
import Label from 'src/components/label';
import { useAppSelector } from 'src/store';
import { fNumber } from 'src/utils/format-number';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  tradeTx: icon('ic-nav-trade'),
  report: icon('ic-nav-report'),
  goldPrice: icon('ic-nav-price'),
  deposit: icon('ic-nav-deposit'),
  topupWithdraw: icon('ic-nav-topup-credit'),
  position: icon('ic-nav-topup'),
  goldWithdraw: icon('ic-nav-withdraw'),
  creditLoan: icon('ic-nav-loan'),
  product: icon('ic-nav-asset'),
  stockImport: icon('ic-nav-deposit'),
  stockExport: icon('ic-nav-withdraw'),
  stockReport: icon('ic-nav-report'),
  user: icon('ic-nav-user'),
  inviteCode: icon('ic-nav-invite'),
  notification: icon('ic-nav-notification'),
  setting: icon('ic-nav-setting'),
  logout: icon('ic-nav-logout'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { notification, transaction } = useAppSelector((state) => state.badge);

  // const topUpWithdraw = transaction.topup + transaction.withdraw;

  const data = useMemo(
    () => [
      {
        subheader: 'ภาพรวม',
        items: [
          // { title: 'การซื้อขาย', path: paths.overview.tradeTx, icon: ICONS.tradeTx },
          { title: 'รายงาน', path: paths.overview.report, icon: ICONS.report },
          // TODO ยังไม่รู้ว่าจะอัพเดทราคา กรัม ยังไง
          // { title: 'อัพเดทราคาสินค้า', path: paths.overview.goldPrice, icon: ICONS.goldPrice },
          {
            title: 'การเติม/ถอนเงิน',
            path: paths.overview.topupWithdraw.root,
            icon: ICONS.topupWithdraw,
            ...((!!transaction?.topup || !!transaction?.withdraw) && {
              info: (
                <Label color="warning">{fNumber(transaction.topup + transaction.withdraw)}</Label>
              ),
            }),
          },
          {
            title: 'การตัดซื้อ/ขาย',
            path: paths.overview.position,
            icon: ICONS.position,
            ...(!!transaction?.position && {
              info: <Label color="warning">{fNumber(transaction.position)}</Label>,
            }),
          },
          {
            title: 'ถอนสินค้า',
            path: paths.overview.redeem,
            icon: ICONS.goldWithdraw,
            ...(!!transaction?.redeem && {
              info: <Label color="warning">{fNumber(transaction.redeem)}</Label>,
            }),
          },
          {
            title: 'ฝากสินค้า',
            path: paths.overview.deposit,
            icon: ICONS.deposit,
            ...(!!transaction?.deposit && {
              info: <Label color="warning">{fNumber(transaction.deposit)}</Label>,
            }),
          },
          {
            title: 'วงเงินหลักประกัน',
            path: paths.overview.topUpDeposit,
            icon: ICONS.creditLoan,
            ...(!!transaction?.topupDeposit && {
              info: <Label color="warning">{fNumber(transaction.topupDeposit)}</Label>,
            }),
          },
          {
            title: 'ธุรกรรมใกล้หมดอายุ',
            path: paths.overview.expiringTx,
            icon: ICONS.position,
            ...(!!transaction?.almostExpired && {
              info: <Label color="warning">{fNumber(transaction.almostExpired)}</Label>,
            }),
          },
        ],
      },
      {
        subheader: 'สต็อก (โรงงาน)',
        items: [
          {
            title: 'สต็อก',
            path: paths.stock.summary,
            icon: ICONS.product,
          },
          {
            title: 'รายการรับเข้า',
            path: paths.stock.import,
            icon: ICONS.stockImport,
          },
          {
            title: 'รายการจ่ายออก',
            path: paths.stock.export,
            icon: ICONS.stockExport,
          },
        ],
      },
      {
        subheader: 'สต็อก (ลูกค้า)',
        items: [
          {
            title: 'รายงานสต็อก',
            path: paths.stock.report,
            icon: ICONS.stockReport,
          },
        ],
      },
      {
        subheader: 'การจัดการอื่น ๆ',
        items: [
          {
            title: 'แจ้งเตือน',
            path: paths.management.notification,
            icon: ICONS.notification,
            ...(!!notification.unReadCount && {
              info: <Label color="warning">{fNumber(notification.unReadCount)}</Label>,
            }),
          },
          {
            title: 'รหัสเชิญ',
            path: paths.management.inviteCode.root,
            icon: ICONS.inviteCode,
          },
          {
            title: 'ผู้ใช้งาน',
            path: paths.management.user.root,
            icon: ICONS.user,
          },
          {
            title: 'สินค้า',
            path: paths.management.product.root,
            icon: ICONS.product,
          },
          {
            title: 'ตั้งค่า',
            path: paths.management.setting,
            icon: ICONS.setting,
          },
          {
            title: 'ออกจากระบบ',
            path: '/logout',
            icon: ICONS.logout,
          },
        ],
      },
    ],
    [notification, transaction]
  );

  return data;
}
